// extracted by mini-css-extract-plugin
export default {"container":"ResetForm_container__3BS1E","title":"ResetForm_title__uwdQv","actions":"ResetForm_actions__jaUuO"};